// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2873": "1e2f623a","6596": "2f071f8a","6924": "905ed424",}[chunkId] + ".css"
}